export const COMPANY_SIZE_OPTIONS = [
  { value: '1-10', label: '1 - 10' },
  { value: '11-50', label: '11 - 50' },
  { value: '51-200', label: '51 - 200' },
  { value: '201-500', label: '201 - 500' },
  { value: '500+', label: '500+' },
];

export const INDUSTRY_OPTIONS = [
  { value: 'Aerospace & Defense', labelKey: 'AEROSPACE_DEFENSE' },
  { value: 'Agriculture & Food', labelKey: 'AGRICULTURE_FOOD' },
  { value: 'Automotive & Transportation', labelKey: 'AUTOMOTIVE_TRANSPORT' },
  { value: 'Chemicals & Materials', labelKey: 'CHEMICALS_MATERIALS' },
  { value: 'Construction & Built Environment', labelKey: 'CONSTRUCTION' },
  { value: 'Consumer Packaged Goods (CPG)', labelKey: 'CPG' },
  { value: 'Education', labelKey: 'EDUCATION' },
  { value: 'Entertainment', labelKey: 'ENTERTAINMENT' },
  { value: 'Finance', labelKey: 'FINANCE' },
  { value: 'Government & Nonprofit', labelKey: 'GOVERNMENT_NONPROFIT' },
  { value: 'Healthcare', labelKey: 'HEALTHCARE' },
  { value: 'Hospitality & Tourism', labelKey: 'HOSPITALITY_TOURISM' },
  { value: 'Industrial & Energy', labelKey: 'INDUSTRIAL_ENERGY' },
  { value: 'Legal & Compliance', labelKey: 'LEGAL_COMPLIANCE' },
  { value: 'Lifestyle & Leisure', labelKey: 'LIFESTYLE_LEISURE' },
  { value: 'Logistics & Supply Chain', labelKey: 'LOGISTICS_SUPPLY' },
  { value: 'Luxury & Fashion', labelKey: 'LUXURY_FASHION' },
  { value: 'News & Media', labelKey: 'NEWS_MEDIA' },
  {
    value: 'Professional Services & Agencies',
    labelKey: 'PROFESSIONAL_SERVICES',
  },
  { value: 'Real Estate & PropTech', labelKey: 'REAL_ESTATE' },
  { value: 'Retail & E-commerce', labelKey: 'RETAIL_ECOMMERCE' },
  { value: 'Sports', labelKey: 'SPORTS' },
  { value: 'Technology', labelKey: 'TECHNOLOGY' },
  { value: 'Telecommunications', labelKey: 'TELECOMMUNICATIONS' },
  { value: 'Other', labelKey: 'OTHER' },
];

export const REFERRAL_SOURCE_OPTIONS = [
  { value: 'google', labelKey: 'GOOGLE' },
  { value: 'reddit', labelKey: 'REDDIT' },
  { value: 'twitter', labelKey: 'TWITTER' },
  { value: 'linkedin', labelKey: 'LINKEDIN' },
  { value: 'friend', labelKey: 'FRIEND' },
  { value: 'blog', labelKey: 'BLOG' },
  { value: 'github', labelKey: 'GITHUB' },
  { value: 'other', labelKey: 'OTHER' },
];

export const USER_ROLE_OPTIONS = [
  { value: 'founder', labelKey: 'FOUNDER' },
  { value: 'product_manager', labelKey: 'PRODUCT_MANAGER' },
  { value: 'engineering', labelKey: 'ENGINEERING' },
  { value: 'support_lead', labelKey: 'SUPPORT_LEAD' },
  { value: 'marketing', labelKey: 'MARKETING' },
  { value: 'sales', labelKey: 'SALES' },
  { value: 'other', labelKey: 'OTHER' },
];
